<template>
    <p v-if="formMessage" class="form-message" :class="{'message-error': isFormSubmitted === false}">{{ formMessage }}</p>
</template>

<script>
import { ref, getCurrentInstance, onMounted, onBeforeUnmount } from 'vue';
export default {
    name: "FormMessage",
    props: {
     isFormSubmitted: {
        type: Boolean,
     },
    },
    setup() {
        const formMessage = ref('');
        const { proxy } = getCurrentInstance();

        const showMessage = (msg) => {
          formMessage.value = msg;
        };

        onMounted(() => {
          proxy.$eventBus.on('form-message', showMessage);
        });

        onBeforeUnmount(() => {
          proxy.$eventBus.off('form-message', showMessage);
        });

        return {
            formMessage,
        }

    }
};

</script>

<style scoped>
.form-message {
  width: 250px;
  position: fixed;
  top: 350px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 1;
  background-color: #4caf50;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  text-align: center;
}

.message-error {
    background-color: #ed4337;
}


@media screen and (max-width: 768px) {
.form-message {
    font-size: 16px;
  }
}

@media screen and (max-width: 360px) {
.form-message {
    font-size: 14px;
  }
}
</style>